import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SccConfirmDataComponent } from './scc-confirm-data.component';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../../pipes/pipes.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonDialogService } from '../common.dialog.service';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    SccConfirmDataComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PipesModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule
  ],
  providers: [
    CommonDialogService
  ],
})
export class SccConfirmDataModule { }
